import { GET_FILTER_USERS, GET_SUBORDINATES_LEARNING } from "@/api/mytna-report/mytna-report";

const handleRequest = async (apiFunc, commit, mutation, args, emptyValue = []) => {
  try {
    const resp = await apiFunc(args);
    const { httpCode, data } = resp.data;

    if (httpCode === 200) {
      if (data?.data && data?.totalItems !== undefined) {
        const payload = {
          ...data,
          data: data.data,
          totalItems: data.totalItems,
          page: data.page,
          limit: data.limit,
          totalPages: data.totalPages,
        };
        commit(mutation, payload);
        return payload;
      }

      commit(mutation, data);
      return data;
    }

    commit(mutation, emptyValue);
    return emptyValue;
  } catch (err) {
    const resp = err?.response?.data;
    if (resp?.httpCode === 404) {
      commit(mutation, emptyValue);
    }
    throw err;
  }
};

const state = {
  subordinatesLearning: {
    data: [],
    totalItems: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
    totalLearningItems: 0,
  },
  filterUserOptions: {
    company: [],
    division: [],
    department: [],
    position: [],
    employee: [],
  },
};

const mutations = {
  setSubordinatesLearning: (state, payload) => {
    state.subordinatesLearning = {
      data: payload?.data ?? [],
      totalItems: payload?.totalItems ?? 0,
      page: payload?.page ?? 1,
      limit: payload?.limit ?? 10,
      totalPages: payload?.totalPages ?? 0,
      totalLearningItems: payload?.totalLearningItems ?? 0,
    };
  },

  setFilterUsers: (state, payload) => {
    const employee = payload?.employees?.map((item) => ({
      ...item,
      value: item.nik,
      text: `${item.fullname} - ${item.nik}`,
    }));

    state.filterUserOptions = {
      company: payload?.company || [],
      division: payload?.division || [],
      department: payload?.department || [],
      position: payload?.position || [],
      employee: employee || [],
    };
  },
};

const actions = {
  async getSubordinatesLearning({ commit }, query) {
    return handleRequest(GET_SUBORDINATES_LEARNING, commit, "setSubordinatesLearning", query, {
      data: [],
      totalItems: 0,
      page: 1,
      limit: 10,
      totalPages: 0,
      totalLearningItems: 0,
    });
  },

  async getUserByFilters({ commit }, data) {
    return handleRequest(GET_FILTER_USERS, commit, "setFilterUsers", data, []);
  },
};

const getters = {
  subordinatesLearning: (state) => state.subordinatesLearning,
  filterUserOptions: (state) => state.filterUserOptions,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
